import gql from 'graphql-tag';

export default gql`
  query filesForExercise($lessonId: MongoID!, $exerciseId: MongoID!, $index: Int!) {
    filesForExercise(lessonId: $lessonId, exerciseId: $exerciseId, index: $index) {
      _id
      name
      description
      interactionIcon
      path
      status
      data {
        isShared
        isLink
        isPublicAccess
      }
      createdAt
      type
      size
    }
  }
`;
